import React, { useEffect, useState } from 'react'
import newzxg from '../../../../modules/newzxg/web'
import { store } from '../../../../store/favor/store'
import { Observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { NoticeTipDialog } from '../../../shared/notice'


export function FavorGroupPanel(props: {
  type: 'create' | 'edit',
  currentFavor?: any,
  onClose:Function
}) {
  const [groupName, setGroupName] = useState(props.currentFavor?.name)
  const [noticeTip, setNoticeTip] = useState({ noticeVisible: false, noticeContent: '' })
  const [slide, setSlide] = useState("")
  let timer:any = null

  //添加组合
  const addGroup = async (groupName: string) => {
    let result = await newzxg.addGroup(groupName)
    if (result && result.re) {
      let getgid = result?.result?.gid
      store.setFavors([...toJS(store.favors), getgid])
      setNoticeTip({
        noticeVisible: true,
        noticeContent: '组合添加成功',
      })
      let data = await store.getGroupList()
      store.setGroupList(data)
      setSlide("")
      timer = setTimeout(()=>{
        props.onClose()
      },300)
    } else {
      if (result.message) {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: result.message,
        })
      } else {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: '组合添加失败',
        })
      }
    }
  }

  const backToPage = () => {
    setSlide("")
    timer = setTimeout(()=>{
      props.onClose()
    },300)
  }

  //获取添加分组标题并验证
  const getAddFavorGroupTitle = () => {
    let groupTitle = groupName
    if (groupTitle) {
      return {
        status: 0,
        msg: '分组标题合法',
        value: groupTitle
      }
    } else {
      return {
        status: -1,
        msg: '名称不能为空',
        value: ''
      }
    }
  }

  //修改组合名称
  const updateGroupName = async (id: string, name: string) => {
    let result = await newzxg.editGroupName(id, name)
    if (result && result.re) {
      setNoticeTip({
        noticeVisible: true,
        noticeContent: '组合编辑成功',
      })
      setSlide("")
      timer = setTimeout(()=>{
        props.onClose()
      },300)
      // 重新请求
      let data = await store.getGroupList()
      store.setGroupList(data)
      if(id == props.currentFavor.gid){
        store.setTitle(name)
      }
    } else {
      if (result.message == '组合名称不符合规范' && name == '自选股') {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: '股票分组名不能使用默认自选组名',
        })
      } else {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: result.message,
        })
      }
    }
  }

  const onConfirm = () => {
    let getGroup = getAddFavorGroupTitle()
    if (getGroup.status == 0) {
      if (props.type == 'create') {
        //添加分组
        addGroup(getGroup.value)
      } else {
        //修改分组
        let code = props.currentFavor.id
        if (!code) {
          setNoticeTip({
            noticeVisible: true,
            noticeContent: '无效的编辑操作',
          })
          return
        }
        updateGroupName(code, groupName)
      }
    } else {
      setNoticeTip({
        noticeVisible: true,
        noticeContent: getGroup.msg,
      })
    }
  }

  const onInputChange = (e: any) => {
    setGroupName(e.target.value)
  }

  useEffect(()=>{
    setSlide("slide-left")
    return ()=>{timer && clearTimeout(timer)}
  }, [])

  return (
    <Observer>
      {() => (
        <>
          <div className={`group-add-pop ${slide}`}>
            <p className="head addgroup-pop">
              <a href="#" className="icon-slide" onClick={(e)=>{e.preventDefault();backToPage()}}></a>
              <span id="groupedit-title">{props.type == 'create' ? '新建自选股组' : '编辑自选股组'}</span>
            </p>
            <div className="form-wrap">
              <input
                type="text"
                placeholder="请输入组合名称"
                onChange={(e) => {
                  onInputChange(e)
                }}
                defaultValue={groupName}
              />
              <p className="word-count">最多10个汉字或20个字符</p>
            </div>
            <a href="#" className="btn btn-blue" onClick={(e)=>{e.preventDefault();onConfirm()}}>
              确认
            </a>
          </div>
          {noticeTip.noticeVisible && <NoticeTipDialog content={noticeTip.noticeContent} noIcon={true} onClose={() => setNoticeTip({ noticeVisible: false, noticeContent: '' })} />}
        </>
      )}
    </Observer>
  )
}
